export default function isString(value) {
    return typeof value === "string";
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@telerik/kendo-intl/dist/es/common/is-string.js
// module id = 474
// module chunks = 30